import React, { useEffect, useState } from 'react';
import { EmAbertoColumnFilterPanel } from './EmAbertoColumnFilterPanel';
import { usesTechnicianRetorno } from './filterScopeUtils';
import {
  BoardSearchTechnicianPrevisaoPanel,
  BoardSearchTechnicianRetornoPanel,
} from './BoardSearchTechnicianPopoverPanels';

export function BoardSearchFilterPanelRouter({
  filterType,
  filterScope,
  displayFilters,
  onApply,
  onClose,
  countsProps,
  previsaoWithCounts = [],
  retornoCounts,
}) {
  const [tempFilters, setTempFilters] = useState(() => ({ ...displayFilters }));

  useEffect(() => {
    setTempFilters({ ...displayFilters });
  }, [displayFilters, filterType, filterScope]);

  const applyFilters = () => {
    onApply(tempFilters);
    onClose();
  };

  const clearFilters = () => {
    const cleared = { ...tempFilters };
    if (filterType === 'previsao') cleared.previsao = [];
    else if (filterType === 'osFutura') cleared.osFuturaRange = null;
    else if (filterType === 'retorno') cleared.retorno = null;
    else if (filterType === 'cidade') cleared.cidade = [];
    else if (filterType === 'bairro') cleared.bairro = [];
    else if (filterType === 'cliente') cleared.cliente = [];
    else if (filterType === 'tipoOS') cleared.tipoOS = [];
    else if (filterType === 'sla') cleared.sla = [];
    else if (filterType === 'equipamento') cleared.equipamento = [];
    else if (filterType === 'status') cleared.status = [];
    else if (filterType === 'tecnicoInicial') cleared.tecnicoInicial = [];
    else if (filterType === 'defeitoDescricao') cleared.defeitoDescricao = [];
    else if (filterType === 'defeitoAlert') cleared.defeitoAlert = [];
    else if (filterType === 'defeitoClassification') cleared.defeitoClassification = [];
    else if (filterType === 'defeitoSeverity') cleared.defeitoSeverity = [];
    setTempFilters(cleared);
  };

  if (!filterType || filterType === 'osFutura') return null;

  if (filterType === 'previsao') {
    return (
      <BoardSearchTechnicianPrevisaoPanel
        previsaoWithCounts={previsaoWithCounts}
        tempFilters={tempFilters}
        setTempFilters={setTempFilters}
        applyFilters={applyFilters}
        clearFilters={clearFilters}
        onApplyLive={(next) => onApply(next)}
      />
    );
  }

  if (filterType === 'retorno' && usesTechnicianRetorno(filterScope)) {
    return (
      <BoardSearchTechnicianRetornoPanel
        tempFilters={tempFilters}
        setTempFilters={setTempFilters}
        applyFilters={applyFilters}
        clearFilters={clearFilters}
        retornoCounts={retornoCounts}
        onApplyLive={(next) => onApply(next)}
      />
    );
  }

  return (
    <EmAbertoColumnFilterPanel
      variant="popover"
      filterType={filterType}
      onClose={onClose}
      selectedColumnFilters={tempFilters}
      onApplyLive={(next) => onApply(next)}
      setSelectedColumnFilters={(next) => {
        const resolved = typeof next === 'function' ? next(tempFilters) : next;
        onApply(resolved);
        onClose();
      }}
      {...countsProps}
    />
  );
}
